// Rótulo "Nh corridas · Mh operacionais" do sandbox. Só o par quando há
// calendário (effectiveHours != null); 24/7 mostra apenas as horas corridas. Puro (testável).

function fmtHours(h: number): string {
  const rounded = Math.round(h * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

export function operatingHoursLabel(
  runningHours: number | null,
  effectiveHours: number | null
): string {
  // Sem horas corridas conhecidas não há período a resumir. O travessão é a única
  // resposta honesta: qualquer número aqui seria assumido, e assumido lê-se como medido.
  if (runningHours == null) return "—";
  if (effectiveHours == null) return `${fmtHours(runningHours)}h`;
  return `${fmtHours(runningHours)}h corridas · ${fmtHours(effectiveHours)}h operacionais`;
}
